import { PdBaseUI } from "../base/pd-base-ui.js";
import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { css, html } from "lit";
import { property } from "lit/decorators.js";
//#region src/pd-form-field/PdFormField.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Wrapper for custom content within pd-form-row.
*
* Use this component to include non-pd form elements (custom components,
* native HTML, etc.) in a pd-form-row while maintaining proper grid layout.
*
* @tagname pd-form-field
* @summary Grid-aware wrapper for non-pd form elements.
*
* @slot - Custom content to display.
*
* @example
* ```html
* <pd-form-row>
*   <pd-input span="half" label="Name"></pd-input>
*   <pd-form-field span="half">
*     <my-custom-component></my-custom-component>
*   </pd-form-field>
* </pd-form-row>
* ```
*/
var PdFormField = class extends PdBaseUI {
	constructor(..._args) {
		super(..._args);
		this.span = "full";
	}
	static {
		this.styles = [PdBaseUI.styles, css`
      :host {
        display: block;
        box-sizing: border-box;
      }
    `];
	}
	render() {
		return html`<slot></slot>`;
	}
};
__decorate([property({
	type: String,
	reflect: true
})], PdFormField.prototype, "span", void 0);
//#endregion
export { PdFormField };
